<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar mb-4">
			<v-tabs style="flex-grow: 0" v-model="tab">
				<v-tab>Details</v-tab>
				<v-tab v-if="$route.params.id != null">User input values</v-tab>
				<v-tab v-if="$route.params.id != null">Formula values</v-tab>
				<v-tab v-if="$route.params.id != null">Output</v-tab>
				<v-tab v-if="$route.params.id != null">Filters</v-tab>
			</v-tabs>
		</div>
		<v-container :fluid="true" class="grid-flex-container pt-0 d-flex">
			<activity-details v-if="tab == 0" />
			<activity-static-fields v-if="tab == 1" />
			<activity-computed-fields v-if="tab == 2" />
			<activity-item v-if="tab == 3" />
			<activity-filters v-if="tab == 4" />
		</v-container>
	</div>
</template>
<script>
import ActivityDetails from './activityDetails/ActivityDetails.vue';
import ActivityComputedFields from './activityComputedFields/ActivityComputedFields.vue';
import ActivityStaticFields from './activityStaticFields/ActivityStaticFields.vue';
import ActivityFilters from './activityFilters/ActivityFilter.vue';
import ActivityItem from './activityItem/ActivityItem.vue';
import { ActivityDetailsActions } from '../../../store/actions';

export default {
	components: {
		ActivityDetails,
		ActivityComputedFields,
		ActivityFilters,
		ActivityItem,
		ActivityStaticFields,
	},
	name: 'AddActivity',
	data() {
		return {
			tab: null,
			id: null,
			items: [
				{
					Name: 'Details',
					content: 'ActivityDetails',
				},
			],
		};
	},
	destroyed() {
		this.$store.dispatch(ActivityDetailsActions.CLEAR);
	},
};
</script>
<style lang="scss">
.v-tabs-bar {
	height: 41px;
}

.grid-flex-container {
	overflow-y: scroll;
}
</style>
